import { render, staticRenderFns } from "./RecapitulalifGarde.vue?vue&type=template&id=48835e12"
import script from "./RecapitulalifGarde.vue?vue&type=script&lang=ts"
export * from "./RecapitulalifGarde.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports